import { render } from "./Controller.vue?vue&type=template&id=4ac23706&scoped=true"
import script from "./Controller.vue?vue&type=script&lang=js"
export * from "./Controller.vue?vue&type=script&lang=js"

import "./Controller.vue?vue&type=style&index=0&id=4ac23706&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac23706"]])

export default __exports__